<template>
  <v-card class="saving-opportunity-card" :ripple="false" elevation="0">
    <div class="card-content">
      <div class="top-section d-flex justify-space-between align-center">
        <span class="label">{{ label }}</span>
        <span v-if="labelValue" class="amount font-weight-bold">{{ labelValue }}</span>
      </div>

      <v-divider class="my-2"></v-divider>

      <div class="bottom-section d-flex align-center">
        <div class="logo-url" :class="{ 'logo-background': savingPercentage == 0 }">
          <img :src="logoUrl" class="logo-image">
        </div>
        <div class="savings-info">
          <div class="saving-amount font-weight-bold">{{ savingAmount }}</div>
          <div class="saving-percentage">{{ savingPercentage }}%</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'VoucherSavingSuggestions',
  props: {
    label: {
      type: String
    },
    labelValue: {
      type: [String, Number],
      required: false
    },
    logoBackgroundColor: {
      type: String,
      default: '#F58220' // Default to orange
    },
    logoUrl: {
      type: String,
      required: true,
      default: require('@/assets/credit-card.png')
    },
    logoAltText: {
      type: String,
      default: 'merchant logo'
    },
    savingAmount: {
      type: String,
      required: true
    },
    savingPercentage: {
      type: [String, Number],
      required: true
    },
    formatter: {default: null},
  }
};
</script>

<style scoped>
.saving-opportunity-card {
  border-radius: 12px;
  padding: 12px;
  height: 120px;
}

.card-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.top-section .label {
  font-size: 11px;
}

.top-section .amount {
  font-size: 13px;
}

.savings-info {
  margin-left: auto;
  text-align: right;
}

.logo-image {
  width: 60%;
  height: 60%;
  object-fit: contain;
}

.saving-amount {
  font-size: 20px;
}

.saving-percentage {
  font-size: 11px;
  text-align: right;
}

.logo-url {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  margin-top: 10px;
}

.logo-url img {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  position: relative;
  z-index: 2;
}

.logo-url.logo-background {
  width: 40px;
  height: 40px;
  background: #F9F7F3;
  border-radius: 50%;
  margin-right: 16px;
  margin-top: 0px;
}
</style>
